export const en = {
    'banner-default-body': 'The text of your ad for a service or product.',
    'banner-default-domain': 'domain',
    'banner-default-title': 'Ad title'
};
